import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import HeaderTop from './HeaderTop';
import MainMenu from './MainMenu';
import { Container,Row,Col,Image } from 'react-bootstrap';
import { useDataContext } from '../DataContext';
export default function Header() 
{
    const { t } = useTranslation();
    const { globalData } = useDataContext();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    let SiteName = (globalData) ? globalData.sg_name : t('SiteName');
    let Tagline = (globalData) ? globalData.sg_tagline : t('TagLine');
    if( appLanguage === 'hi' )
    {
        SiteName = ( globalData && globalData.sg_name_hi ) ? globalData.sg_name_hi : SiteName;
        Tagline = ( globalData && globalData.sg_tagline_hi ) ? globalData.sg_tagline_hi : Tagline;
    }
    const convertNewlinesToBr = (text) => {
        return { __html: text.replace(/(\r\n|\n)/g, '<br />') };
    };
    return (
        <header id='Header-Main' className="header">
            <HeaderTop />
            <Container className='header-mid'>                 
                <Row className='align-items-center py-2 overflow-hidden'>
                    <Col md={8} sm={12}>
                        <Link className="d-flex align-items-center navbar-brand text-wrap" to="/" aria-label={appLanguage === 'hi' ? 'लोगो से होम पेज पर जाएं' : 'From the logo go to home page'}>
                            <Image src={global.config.uploadPath+'2041938450.png'} alt={appLanguage === 'hi' ? `${SiteName} प्रतीक चिन्ह` : `${SiteName} logo`} loading="lazy" fluid className='site-logo' width={100} height={100} data-aos="flip-left" data-aos-duration="1500" />
                            <div className="ps-lg-3 ps-2 text-start flex-fill" data-aos="fade-right" data-aos-duration="1500">
                                <div className="site-title">{SiteName}</div>
                                <div className='site-tagline' dangerouslySetInnerHTML={convertNewlinesToBr(Tagline)} />
                            </div>
                        </Link>                        
                    </Col>
                    <Col md={4} sm={12} className="d-none d-md-flex align-items-center justify-content-end gap-2">
                        <Image src={global.config.uploadPath+"242932330.png"} alt={t('NAAC')} loading="lazy" fluid width={135} height={80} data-aos="flip-right" data-aos-duration="1000" />
                        <Image src={global.config.uploadPath+"754264224.png"} alt={t('NationalEmblem')} loading="lazy" fluid className='img-light' width={42} height={80} data-aos="flip-right" data-aos-duration="1000" />
                        <Image src={global.config.uploadPath+"131917926.png"} alt={t('NationalEmblem')} loading="lazy" fluid className='img-dark' width={42} height={80} data-aos="flip-right" data-aos-duration="1000" />
                        <Image src={global.config.uploadPath+"1259275927.jpg"} alt={t('NationalFlag')} loading="lazy" fluid width={108} height={80} data-aos="flip-right" data-aos-duration="1000" />
                    </Col>               
                </Row>
            </Container>
            <MainMenu/>                      
        </header>
    );
  }